import React from "react";

const DocumentationForBillingNote = () => {
  return (
    <div className="bg-gray-10 p-2  flex flex-col max-w-[520px] ">
      <p className="text-teal-300 text-sm text-start font-normal">
        If a prescription is filled at an alternate pharmacy,
        <br />
        this documentation form can be used to support billing
        <br />
        as proof of service, for the Minor Ailments Prescribing Assessment.
      </p>
    </div>
  );
};

export default DocumentationForBillingNote;
